import type { JSX } from 'react';
import type { UseFormRegister, FieldErrors } from 'react-hook-form';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { CountrySelect } from '@/components/molecules/CountrySelect';

export interface CandidateFormData {
  name: string;
  email: string;
  country?: string | null;
  phone?: string | null;
}

interface CandidateFormFieldsProps {
  register: UseFormRegister<CandidateFormData>;
  errors: FieldErrors<CandidateFormData>;
  onCountryChange?: (value: string) => void;
  defaultCountry?: string | null;
}

export function CandidateFormFields({
  register,
  errors,
  onCountryChange,
  defaultCountry,
}: CandidateFormFieldsProps): JSX.Element {
  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="name">
          Name <span className="text-destructive">*</span>
        </Label>
        <Input id="name" placeholder="John Doe" {...register('name')} />
        {errors.name && <p className="text-sm text-destructive">{errors.name.message}</p>}
      </div>

      <div className="space-y-2">
        <Label htmlFor="email">
          Email <span className="text-destructive">*</span>
        </Label>
        <Input id="email" type="email" placeholder="john.doe@example.com" {...register('email')} />
        {errors.email && <p className="text-sm text-destructive">{errors.email.message}</p>}
      </div>

      <div className="space-y-2">
        <Label htmlFor="phone">Phone</Label>
        <Input id="phone" type="tel" placeholder="+381641234567" {...register('phone')} />
        {errors.phone && <p className="text-sm text-destructive">{errors.phone.message}</p>}
      </div>

      <div className="space-y-2">
        <Label htmlFor="country">Country</Label>
        <CountrySelect value={defaultCountry} onValueChange={onCountryChange ?? (() => {})} />
        {errors.country && <p className="text-sm text-destructive">{errors.country.message}</p>}
      </div>
    </div>
  );
}
